import { formatDate } from "@angular/common";
import { CalcTemplate } from "./calctemplate";
import { Component_MAWP } from "./component_mawp";
import { Component_MAEP } from "./component_maep"
import { LTA_module } from "./lta_module";
import { Utility } from "./utility";
import { FormControl } from "@angular/forms";
import { GMLReportService } from "./gml_report.service";

export class GML_module {
  public static validationMessage = [];
  public static intanalysis_type: number = -1; // Analysis type, 0 - average measured thickness, 1 - MAWP and MFH
  public static tc_from_gml: number = -1; // temp variable to hold tc value for external pressure calculation
  public static sngtam: number = -1; // average measured thickness
  public static gmlCalcResult = "";
  public static isExternalLoading: boolean = false; // Flag to indicate loading type: false = Internal, true = External

  //for saving in json file 
  public static inpt1_text:string ="";
  public static inpt2_text:string ="";
  public static inpt1:string ="";
  public static inpt2:string ="";
  public static Cmptype:string="";
  public static typearesultval:string="";
  public static typeAradsel:string="";
  public static unitType:string="";
  public static typedamageval:string="";
   // Add a loading type property: 0 = Internal, 1 = External
  public static intLoadingType: number = -1;
  static inttypeA_passorfail: number;
  GML_module() {
    GML_module.GML_initialize();
  }

  public static GML_initialize(): void {
    //initialize all the variables
    this.intanalysis_type = -1;
    this.sngtam = -1;
    LTA_module.sngtmm = -1;
    CalcTemplate.sngFCAml = -1;
    this.gmlCalcResult = "";
    this.isExternalLoading = false;
  }

  public static ReturnGMLValuesAsHTML(): string {
    let result =
      "intanalysis_type: " +
      this.intanalysis_type +
      "</br>" +
      "sngtam: " +
      this.sngtam;

    return result;
  }

 public static ExportToJson(radioButtonDI: string): string {
    //shameer-start
    if(parseInt(localStorage.getItem("TypeAradioselection")) == 1) // for vertical popup
    {
      // for Vertical Vessel

        const userinputs = localStorage.getItem('verticalinputs');
        const Input_data = userinputs ? JSON.parse(userinputs) : null;
        const a1 = Input_data.inputvalue1;
        const a2 = Input_data.inputvalue2;

       // this is used for saving in json file
        this.inpt1 = a1;
        this.inpt2 = a2;

        if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
        {
        this.inpt1_text = "Vertical Location of the Flaw, H (inch)" ;
        this.inpt2_text = "nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
        }
        else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
        {
          this.inpt1_text = "Vertical Location of the Flaw, H*  (mm) *" ;
          this.inpt2_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";             
        }

      } 
      else if (parseInt(localStorage.getItem("TypeAradioselection")) == 2) //for horizontal popup
       {
          //for Horizontal Vessel

          const userinputs = localStorage.getItem('horizontalinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
 
           // this is used for saving in json file
            this.inpt1 = a1;
            this.inpt2 = a2;

            if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
            {
              this.inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *" ;
              this.inpt2_text = "Distance between saddle supports Lss  (inch) *";
            }
            else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
            {
              this.inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *" ;
              this.inpt2_text = "nDistance between saddle supports Lss  (mm) *";
            }

        }
        else if(parseInt(localStorage.getItem("TypeAradioselection")) == 3) //for Carbon and low alloy
       {
          const userinputs = localStorage.getItem('carbonsteelinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
           
                  // this is used for saving in json file
                  this.inpt1 = a1;
                  this.inpt2 = a2;

                  if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℉)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (inch)";
                  }
              else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℃)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (mm)";
                  }

         }
       
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 4) //for High alloy and Nonferrous
           {
                //for High Alloy and Nonferrous Steel

              const userinputs = localStorage.getItem('highalloyinputs');
              const Input_data = userinputs ? JSON.parse(userinputs) : null;
              const a1 = Input_data.inputvalue1;
              const a2 = Input_data.inputvalue2;

                // this is used for saving in json file
                  this.inpt1 = a1;
                  this.inpt2 = a2;

                  if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
                  {
                    this.inpt1_text  = "Maximum Operating Temperature, Top  (℉)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (inch)";
                  }
                  else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℃)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (mm)";
                  }
      
             }
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 5) //for Spherical Components
           {
                  // this is used for saving in json file
 		              this.inpt1 = "";
                  this.inpt2 = "";
                  this.inpt1_text = "" ;
                  this.inpt2_text = "";
           }
        if(radioButtonDI.toString().toUpperCase() == "radioButton1_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAWP.getComponentType(Component_MAWP.intEquip);
        else if(radioButtonDI.toString().toUpperCase() == "radioButton2_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAEP.getComponentType(Component_MAEP.intEquip);


        if(parseInt(localStorage.getItem("TypeAPassorFail")) == 0) 
        {
            this.typearesultval = "FAIL";
        }
        else if(parseInt(localStorage.getItem("TypeAPassorFail")) == 1) 
        {
          this.typearesultval = "PASS";
        }
        

        if(parseInt(localStorage.getItem("TypeAradioselection"))== 1)
        {
          this.typeAradsel ="VerticalVessel";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 2)
        {
            this.typeAradsel ="HorizonalVessel";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 3)
        {
              this.typeAradsel ="CarbonandLowAllySteelPiping";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 4)
        {
                this.typeAradsel ="HighAlloyNonFerrousSteelPiping";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 5)
        {
          this.typeAradsel ="SphericalComponents";
        }

        if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0)
        {
          this.unitType = "US";
        }
        else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1)
        {
          this.unitType = "SI";
        }
      
    //shameer-end
        this.typedamageval = radioButtonDI;
        const dataToExport: any = {};

      if (radioButtonDI.toString().toUpperCase() === "radioButton1_DI_enabled".toUpperCase()) {
        dataToExport.Component_MAWP = { ...Component_MAWP };
      } else if (radioButtonDI.toString().toUpperCase() === "radioButton2_DI_enabled".toUpperCase()) {
        dataToExport.Component_MAEP = { ...Component_MAEP };
      }

      // Always include these modules
      dataToExport.LTA_module = { ...LTA_module };
      dataToExport.CalcTemplate = { ...CalcTemplate };
      dataToExport.GML_module = { ...GML_module };

      dataToExport.typeaData = {
        typeAresult: this.typearesultval,
        TypeARadioSelect: this.typeAradsel,
        Input1_text: this.inpt1_text,
        Input1_value: this.inpt1,
        Input2_text: this.inpt2_text,
        Input2_value: this.inpt2,
        ComponetType: this.Cmptype,
        TypeofUnit: this.unitType
      };

    const jsonData = JSON.stringify(dataToExport);

    return jsonData;
  }

  public static ImportFromJson(jsonDataResult): void {
    
    Component_MAWP.MAWP_initialize();
    Component_MAEP.MAEP_initialize();
    GML_module.GML_initialize();

    Object.assign(Component_MAWP, jsonDataResult.Component_MAWP);
    Object.assign(Component_MAEP, jsonDataResult.Component_MAEP);
    Object.assign(CalcTemplate, jsonDataResult.CalcTemplate);
    Object.assign(LTA_module, jsonDataResult.LTA_module);
    Object.assign(GML_module, jsonDataResult.GML_module);
  }

  public static updateInspectionDataFormControls(
    inspectionDataFormGroup
  ): void {
    let radioButton1_DIformControl: FormControl =
      inspectionDataFormGroup.get("radioButton_DI");
    let textBox1_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox1_DI");
    let textBox2_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox2_DI");
    let textBox3_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox3_DI");

    if (GML_module.intanalysis_type == 0) {
      radioButton1_DIformControl.setValue("radioButton1_DI_enabled");
      radioButton1_DIformControl.enable();
    }

    else if (GML_module.intanalysis_type == 1) {
      radioButton1_DIformControl.setValue("radioButton2_DI_enabled");
      radioButton1_DIformControl.enable();
    }
    if(GML_module.intanalysis_type == 0)
    {
      if (GML_module.sngtam > 0) {
        textBox1_DI_DIformControl.setValue(GML_module.sngtam);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
        textBox1_DI_DIformControl.setValue(GML_module.sngtam);
    }

    if(GML_module.intanalysis_type == 0)
    {
      if (LTA_module.sngtmm > 0) {
        textBox2_DI_DIformControl.setValue(LTA_module.sngtmm);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
      textBox2_DI_DIformControl.setValue(LTA_module.sngtmm);
    }
    
    
    if(GML_module.intanalysis_type == 0)
    {
      if (CalcTemplate.sngFCAml > -1) {
        textBox3_DI_DIformControl.setValue(CalcTemplate.sngFCAml);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
      textBox3_DI_DIformControl.setValue(CalcTemplate.sngFCAml);
    }
  }

  public static check_GML_Data(inspectionDataFormGroup): boolean {
    let messagesValidationsList: string[] = [];
    let msg: string;

    // Check Analysis Type
    const analysisTypeValid = this.checkAnalysisType(
      inspectionDataFormGroup,
      messagesValidationsList
    );

    // Check TAM
    const tamValid = this.checkTam(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Check TMM
    const tmmValid = this.checkTmm(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Check FCAml
    const fcAmlValid = this.checkFCAml(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Combine all validation results
    const overallValidation =
      analysisTypeValid && tamValid && tmmValid && fcAmlValid;
    this.validationMessage = !overallValidation ? messagesValidationsList : [];
    return overallValidation;
  }

  private static checkAnalysisType(
    inspectionDataFormGroup,
    messagesValidationsList: string[]
  ): boolean {
    let pass_flag = true;
    let radioButton_DIformControl: FormControl =
      inspectionDataFormGroup.get("radioButton_DI");

    if (radioButton_DIformControl.enabled) {
      if (
        GML_module.intanalysis_type != 0 &&
        GML_module.intanalysis_type != 1
      ) {
        messagesValidationsList.push("Type of Analysis must be selected.\n");
        pass_flag = false;
      }
    }
    return pass_flag;
  }

  private static checkTam(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
   let pass_flag = true;
   let textBox2_DI_DIformControl: FormControl =
    inspectionDataFormGroup.get("textBox2_DI");

  if (textBox2_DI_DIformControl.enabled) {
    if (!Utility.isTextADouble(textBox2_DI_DIformControl.value)) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm -" + msg + "\n"
      );
      pass_flag = false;
    } else if (LTA_module.sngtmm <= 0) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm - cannot be less than or equal to zero.\n"
      );
      pass_flag = false;
    } else if (LTA_module.sngtmm > this.getActiveNominalThickness()) {
       messagesValidationsList.push(
         "Minimum measured thickness, tmm - cannot be greater than tnom\n"
      );
       pass_flag = false;
    } else if (LTA_module.sngtmm > GML_module.sngtam) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm - cannot be greater than Average measured thickness tam\n"
      );
      pass_flag = false;
    }
  }
  return pass_flag;
  }
	// Add this helper method to handle all component selections
  private static getActiveComponent(): typeof Component_MAWP | typeof Component_MAEP {
    if (Component_MAWP.strRadio === 1 && Component_MAEP.strRadio === 1) {
      return Component_MAEP; // External pressure
    } else {
      return Component_MAWP; // Internal pressure or default
    }
  }
    // Add this method to get the correct sngtnom value based on radio button
  private static getActiveNominalThickness(): number {
    const activeComponent = this.getActiveComponent();
    return activeComponent.sngtnom;
  }
  private static checkTmm(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
    let pass_flag = true;
    let textBox2_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox2_DI");

    if (textBox2_DI_DIformControl.enabled) {
      if (!Utility.isTextADouble(textBox2_DI_DIformControl.value)) {
        messagesValidationsList.push(
          "Minimum measured thickness, tmm -" + msg + "\n"
        );
        pass_flag = false;
      } else if (LTA_module.sngtmm <= 0) {
        messagesValidationsList.push(
          "Minimum measured thickness, tmm - cannot be less than or equal to zero.\n"
        );
        pass_flag = false;
       } //else if (LTA_module.sngtmm > this.getActiveNominalThickness()) {
         //messagesValidationsList.push(
          // "Minimum measured thickness, tmm - cannot be greater than tnom\n"
       // );
        // pass_flag = false;
     // } 
      //else if (LTA_module.sngtmm > GML_module.sngtam) {
      //  messagesValidationsList.push(
       //   "Minimum measured thickness, tmm - cannot be greater than Average measured thickness tam\n"
      //  );
      //  pass_flag = false;
     // }
    }

    

    return pass_flag;
  }

  private static checkFCAml(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
    let pass_flag = true;
    let textBox3_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox3_DI");

    if (textBox3_DI_DIformControl.enabled) {
      if (!Utility.isTextADouble(textBox3_DI_DIformControl.value)) {
        messagesValidationsList.push(
          "Future corrosion allowance inside the damage area, FCAml -" +
            msg +
            "\n"
        );
        pass_flag = false;
      } 
      else if (CalcTemplate.sngFCAml >= LTA_module.sngtmm) {
        messagesValidationsList.push(
          "FCAml - cannot be greater than or equal to tmm.\n"
        );
        pass_flag = false;
      }
    }
    return pass_flag;
  }
  
public static GML_calc(): string {
  // Check loading type: 0 = Internal, 1 = External
  if (GML_module.intLoadingType === 1) {
    // External pressure logic
    return this.GML_calc_externalPressure();
  } else {
    // Internal pressure logic (existing)
    return this.GML_calc_internalPressure();
  }
}
// Calculate GML for external pressure
  public static GML_calc_externalPressure(): string {
    
    let aa: number, bb: number, cc: number, t_lim: number;
    let sngMWAP_localnew_r: number; // added by shameer
    let key1: number, key2: number, key3: number;

    let result = "";

    // First criterion -- tam - FCAml >= tmin or MAWPr >= P_d / MFH_r >= MFH_d
    if (GML_module.intanalysis_type === 0) {
      // average thickness approach
      aa = GML_module.sngtam - CalcTemplate.sngFCAml;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = aa.toFixed(3);
        Component_MAEP.buffer1 = Component_MAEP.sngtmin.toFixed(3);

        //added by shameer
        let pp: number;
        pp = Component_MAEP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        pp = Utility.roundDouble(pp, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= pp) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAEP.buffer} inch  >=  tmin = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAEP.buffer} inch  <  tmin = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = aa.toFixed(1);
        Component_MAEP.buffer1 = Component_MAEP.sngtmin.toFixed(1);

        // added by shameer
        let qq: number;
        qq = Component_MAEP.sngtmin // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        qq = Utility.roundDouble(qq, 1)
        aa = Utility.roundDouble(aa, 1);

        if (aa >= qq) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAEP.buffer} mm  >=  tmin = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAEP.buffer} mm  <  tmin = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // MAWP approach - intanalysis_type = 1
      if (Component_MAEP.intEquip !== 6) {
        // not tanks
        this.tc_from_gml = this.sngtam - CalcTemplate.sngFCAml;
        // adding by shameer
        switch (Component_MAEP.intEquip) {
          case 0: // for cylinder
           // Call the new function with your tc value
           sngMWAP_localnew_r = Component_MAEP.cal_MAEPR_external(this.tc_from_gml);
            break;
          case 1:
            break;
        }

        if (Component_MAEP.intUnit_select === 0) {
          // US customary
          Component_MAEP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAEP.buffer1 = Component_MAEP.sngP_d.toFixed(2);
        } else {
          // SI
          Component_MAEP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAEP.buffer1 = Component_MAEP.sngP_d.toFixed(2);
        }

        if (Component_MAEP.intUnit_select === 0) {
          // US Customary
          if (parseFloat(Component_MAEP.buffer) >= Component_MAEP.sngP_d) {
            key1 = 0;
            result += `MAWP_r based on tam - FCAml = ${Component_MAEP.buffer} psi  >=  Equipment Design Pressure, P_d = ${Component_MAEP.buffer1} psi </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r based on tam - FCAml = ${Component_MAEP.buffer} psi  <  Equipment Design Pressure, P_d = ${Component_MAEP.buffer1} psi  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (parseFloat(Component_MAEP.buffer) >= Component_MAEP.sngP_d) {
            key1 = 0;
            result += `MAWP_r based on tam - FCAml = ${Component_MAEP.buffer} MPa  >=  Equipment Design Pressure, P_d = ${Component_MAEP.buffer1} MPa </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r based on tam - FCAml = ${Component_MAEP.buffer} MPa  <  Equipment Design Pressure, P_d = ${Component_MAEP.buffer1} MPa  <font color="red">*Fail*</font> </br>`;
          }
        }
      } else {
        // tanks
        CalcTemplate.sngMFH_r = CalcTemplate.sngMFH;
        Component_MAEP.buffer = CalcTemplate.sngMFH_r.toFixed(2);
        Component_MAEP.buffer1 = CalcTemplate.sngMFH_d.toFixed(2);
        if (Component_MAEP.intUnit_select === 0) {
          // US Customary
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} ft  >=  Design MFH = ${Component_MAEP.buffer1} ft </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} ft  <  Design MFH = ${Component_MAEP.buffer1} ft  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} m  >=  Design MFH = ${Component_MAEP.buffer1} m </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} m  <  Design MFH = ${Component_MAEP.buffer1} m  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    }
    // Second criterion -- tmm - FCAml >= limiting t based on equipment type
    if (Component_MAEP.intEquip !== 6) {
      // non-tank
      t_lim = 0.2 * Component_MAEP.sngtnom;
    } else {
      // tank
      t_lim = 0.2 * Component_MAEP.sngtc;
    }

    const typeARadio = parseInt(localStorage.getItem("TypeAradioselection") || "0", 10);
    const isTypeAPipingSelection = typeARadio === 3 || typeARadio === 4;
    const isPipingComponent =
      Component_MAEP.intEquip === 5 ||
      Component_MAEP.intEquip === 6 ||
      Component_MAEP.intEquip === 7 ||
      isTypeAPipingSelection;

    if (Component_MAEP.intUnit_select === 0) {
      // US Customary
      console.log("Component_MAWP.intEquip " + Component_MAEP.intEquip);
      if (!isPipingComponent) {
        // non-piping
        if (t_lim < 0.1) t_lim = 0.1;
        Component_MAEP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.1 inch] = ${Component_MAEP.buffer} inch </br>`;
      } else {
        // piping
        if (t_lim < 0.05) t_lim = 0.05;
        Component_MAEP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.05 inch] = ${Component_MAEP.buffer} inch </br>`;
      }
    } else {
      // SI
      if (!isPipingComponent) {
        // non-piping
        if (t_lim < 2.5) t_lim = 2.5;
        Component_MAEP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 2.5 mm] = ${Component_MAEP.buffer} mm </br>`;
      } else {
        // piping
        if (t_lim < 1.3) t_lim = 1.3;
        Component_MAEP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 1.3 mm] = ${Component_MAEP.buffer} mm </br>`;
      }
    }
    // added by shameer - start
    if (Component_MAEP.intEquip !== 8) {
      // non tank
      let aa = 0.9 * GML_module.sngtam;
      let bb = LTA_module.sngtmm - CalcTemplate.sngFCAml;
      let cc = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAEP.sngtmin = Utility.roundDouble(Component_MAEP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk;
        kk = Component_MAEP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to new variable
        kk = Utility.roundDouble(kk, 3);

        Component_MAEP.buffer = cc.toFixed(3);
        Component_MAEP.buffer1 = kk.toFixed(3);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAEP.buffer1 = aa.toFixed(3);
            result +=
              "tam - FCAml = " +
              Component_MAEP.buffer +
              " inch >=  tmin and tmm >= 0.9 * tam = " +
              Component_MAEP.buffer1 +
              " inch </br>";
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAEP.buffer1 = bb.toFixed(3);
              result +=
                "tam - FCAml = " +
                Component_MAEP.buffer +
                " inch >=  tmin and tmm - FCAml = " +
                Component_MAEP.buffer1 +
                " inch >= tmin  </br>";
              key3 = 0;
            } else {
              Component_MAEP.buffer = bb.toFixed(3);
              Component_MAEP.buffer1 = aa.toFixed(3);
              result +=
                "tmm - FCAml = " +
                Component_MAEP.buffer +
                " inch <  tmin and tmm < 0.9 * tam = " +
                Component_MAEP.buffer1 +
                ` inch <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result +=
        //     "tam - FCAml = " +
        //     Component_MAWP.buffer +
        //     " inch <  tmin = " +
        //     Component_MAWP.buffer1 +
        //     ` inch <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      } else {
        // SI

        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAEP.sngtmin = Utility.roundDouble(Component_MAEP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk: number;
        kk = Component_MAEP.sngtmin;
        kk = Utility.roundDouble(kk, 3);

        Component_MAEP.buffer = cc.toFixed(1);
        Component_MAEP.buffer1 = kk.toFixed(1);
        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAEP.buffer1 = aa.toFixed(1);
            result += `tam - FCAml = ${Component_MAEP.buffer} mm >=  tmin and tmm >= 0.9 * tam = ${Component_MAWP.buffer1} mm </br>`;
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAEP.buffer1 = bb.toFixed(1);
              result += `tam - FCAml = ${Component_MAEP.buffer} mm >=  tmin and tmm - FCAml = ${Component_MAWP.buffer1} mm >= tmin  </br>`;
              key3 = 0;
            } else {
              Component_MAEP.buffer = bb.toFixed(1);
              Component_MAEP.buffer1 = aa.toFixed(1);
              result += `tmm - FCAml = ${Component_MAEP.buffer} mm <  tmin and tmm < 0.9 * tam = ${Component_MAWP.buffer1} mm <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result += `tam - FCAml = ${Component_MAWP.buffer} mm <  tmin = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      }
    }
    //added by shameer - end

    if (Component_MAWP.intEquip !== 6) {
      // non tank
      let aa = 0.5 * Component_MAEP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAEP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  >=  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  <  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAEP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  >=  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  <  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // tank
      let aa = 0.6 * Component_MAEP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAEP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  >=  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  <  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAEP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  >=  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  <  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    }
    if (key1 === 0 && key2 === 0) {
      if (key3 === 1) {
        Component_MAEP.strD_result = "Fail";
        result += `</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>`;
      } else {
        Component_MAEP.strD_result = "Pass";
        result +=
          '</br><font color="blue">General Metal Loss passed Level 1 assessment.</font>  </br>';
      }
    } else {
      Component_MAEP.strD_result = "Fail";
      result +=
        '</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>';
    }

    this.gmlCalcResult = result;

    return result;
  }

  // Calculate GML for internal pressure
  public static GML_calc_internalPressure(): string {
   
    let aa: number, bb: number, cc: number, t_lim: number;
    let sngMWAP_localnew_r: number; // added by shameer
    let key1: number, key2: number, key3: number;

    let result = "";

    // First criterion -- tam - FCAml >= tmin or MAWPr >= P_d / MFH_r >= MFH_d
    if (GML_module.intanalysis_type === 0) {
      // average thickness approach
      aa = GML_module.sngtam - CalcTemplate.sngFCAml;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = aa.toFixed(3);
        Component_MAWP.buffer1 = Component_MAWP.sngtmin.toFixed(3);

        //added by shameer
        let pp: number;
        pp = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        pp = Utility.roundDouble(pp, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= pp) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAWP.buffer} inch  >=  tmin = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAWP.buffer} inch  <  tmin = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = aa.toFixed(1);
        Component_MAWP.buffer1 = Component_MAWP.sngtmin.toFixed(1);

        // added by shameer
        let qq: number;
        qq = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        qq = Utility.roundDouble(qq, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= qq) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAWP.buffer} mm  >=  tmin = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAWP.buffer} mm  <  tmin = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      console.log("Component_MAWP.intEquip " + Component_MAWP.intEquip);
      console.log("Component_MAWP " + Component_MAWP);
      // MAWP approach - intanalysis_type = 1
      if (Component_MAWP.intEquip !== 6) {
        // not tanks

        // adding by shameer
        switch (Component_MAWP.intEquip) {
          case 0: // for cylinder
            sngMWAP_localnew_r =
              (Component_MAWP.sngS_stress *
                Component_MAWP.sngE_L *
                (GML_module.sngtam - CalcTemplate.sngFCAml)) /
                (Component_MAWP.sngID / 2.0 +
                  0.6 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
              Component_MAWP.sngp_H;
            break;
        case 1: // for cone
  aa = (Component_MAWP.sngalpha / 360.0) * Math.PI;
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml) *
      Math.cos(aa)) /
      (Component_MAWP.sngID +
        1.2 *
          (GML_module.sngtam - CalcTemplate.sngFCAml) *
          Math.cos(aa)) -
    Component_MAWP.sngp_H;
  break;

case 2: // for sphere
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngID / 2.0 +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;
case 3: // ASME 2-to-1 head
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngID +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 4: // F&D head
  Component_MAWP.sngID =
    2.0 *
    (Component_MAWP.sngIDo +
      Component_MAWP.sngLOSSi +
      Component_MAWP.sngFCAi);
  aa =
    0.25 *
    (3.0 +
      Math.sqrt(Component_MAWP.sngID / 2.0 / Component_MAWP.sngrk));
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (aa * (Component_MAWP.sngID / 2) +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 5: // B31 Piping
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngOD -
        2.0 *
          Component_MAWP.sngY_b *
          (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 6:
  break;
        }

        if (Component_MAWP.intUnit_select === 0) {
          // US customary
          Component_MAWP.buffer = sngMWAP_localnew_r.toFixed(1); // modified by shameer
          Component_MAWP.buffer1 = Component_MAWP.sngP_d.toFixed(1);
        } else {
          // SI
          Component_MAWP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAWP.buffer1 = Component_MAWP.sngP_d.toFixed(2);
        }

        if (Component_MAWP.intUnit_select === 0) {
          // US Customary
          if (sngMWAP_localnew_r >= Component_MAWP.sngP_d) {
            key1 = 0;
            result += `MAWP_r based on tam - FCAml = ${Component_MAWP.buffer} psi  >=  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} psi </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r based on tam - FCAml = ${Component_MAWP.buffer} psi  <  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} psi  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (sngMWAP_localnew_r >= Component_MAWP.sngP_d) {
            key1 = 0;
            result += `MAWP_r based on tam - FCAml = ${Component_MAWP.buffer} MPa  >=  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} MPa </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r based on tam - FCAml = ${Component_MAWP.buffer} MPa  <  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} MPa  <font color="red">*Fail*</font> </br>`;
          }
        }
      } else {
        // tanks
        CalcTemplate.sngMFH_r = CalcTemplate.sngMFH;
        Component_MAWP.buffer = CalcTemplate.sngMFH_r.toFixed(2);
        Component_MAWP.buffer1 = CalcTemplate.sngMFH_d.toFixed(2);
        if (Component_MAWP.intUnit_select === 0) {
          // US Customary
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} ft  >=  Design MFH = ${Component_MAWP.buffer1} ft </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} ft  <  Design MFH = ${Component_MAWP.buffer1} ft  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} m  >=  Design MFH = ${Component_MAWP.buffer1} m </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} m  <  Design MFH = ${Component_MAWP.buffer1} m  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    }
    // Second criterion -- tmm - FCAml >= limiting t based on equipment type
    if (Component_MAWP.intEquip !== 6) {
      // non-tank
      t_lim = 0.2 * Component_MAWP.sngtnom;
    } else {
      // tank
      t_lim = 0.2 * Component_MAWP.sngtc;
    }

    if (Component_MAWP.intUnit_select === 0) {
      // US Customary
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        // non-piping
        if (t_lim < 0.1) t_lim = 0.1;
        Component_MAWP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.1 inch] = ${Component_MAWP.buffer} inch </br>`;
      } else {
        // piping
        if (t_lim < 0.05) t_lim = 0.05;
        Component_MAWP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.05 inch] = ${Component_MAWP.buffer} inch </br>`;
      }
    } else {
      // SI
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        // non-piping
        if (t_lim < 2.5) t_lim = 2.5;
        Component_MAWP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 2.5 mm] = ${Component_MAWP.buffer} mm </br>`;
      } else {
        // piping
        if (t_lim < 1.3) t_lim = 1.3;
        Component_MAWP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 1.3 mm] = ${Component_MAWP.buffer} mm </br>`;
      }
    }
    // added by shameer - start
    if (Component_MAWP.intEquip !== 8) {
      // non tank
      let aa = 0.9 * GML_module.sngtam;
      let bb = LTA_module.sngtmm - CalcTemplate.sngFCAml;
      let cc = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAWP.sngtmin = Utility.roundDouble(Component_MAWP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk;
        kk = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to new variable
        kk = Utility.roundDouble(kk, 3);

        Component_MAWP.buffer = cc.toFixed(3);
        Component_MAWP.buffer1 = kk.toFixed(3);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAWP.buffer1 = aa.toFixed(3);
            result +=
              "tam - FCAml = " +
              Component_MAWP.buffer +
              " inch >=  tmin and tmm >= 0.9 * tam = " +
              Component_MAWP.buffer1 +
              " inch </br>";
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAWP.buffer1 = bb.toFixed(3);
              result +=
                "tam - FCAml = " +
                Component_MAWP.buffer +
                " inch >=  tmin and tmm - FCAml = " +
                Component_MAWP.buffer1 +
                " inch >= tmin  </br>";
              key3 = 0;
            } else {
              Component_MAWP.buffer = bb.toFixed(3);
              Component_MAWP.buffer1 = aa.toFixed(3);
              result +=
                "tmm - FCAml = " +
                Component_MAWP.buffer +
                " inch <  tmin and tmm < 0.9 * tam = " +
                Component_MAWP.buffer1 +
                ` inch <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result +=
        //     "tam - FCAml = " +
        //     Component_MAWP.buffer +
        //     " inch <  tmin = " +
        //     Component_MAWP.buffer1 +
        //     ` inch <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      } else {
        // SI

        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAWP.sngtmin = Utility.roundDouble(Component_MAWP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk: number;
        kk = Component_MAWP.sngtmin;
        kk = Utility.roundDouble(kk, 3);

        Component_MAWP.buffer = cc.toFixed(1);
        Component_MAWP.buffer1 = kk.toFixed(1);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAWP.buffer1 = aa.toFixed(1);
            result += `tam - FCAml = ${Component_MAWP.buffer} mm >=  tmin and tmm >= 0.9 * tam = ${Component_MAWP.buffer1} mm </br>`;
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAWP.buffer1 = bb.toFixed(1);
              result += `tam - FCAml = ${Component_MAWP.buffer} mm >=  tmin and tmm - FCAml = ${Component_MAWP.buffer1} mm >= tmin  </br>`;
              key3 = 0;
            } else {
              Component_MAWP.buffer = bb.toFixed(1);
              Component_MAWP.buffer1 = aa.toFixed(1);
              result += `tmm - FCAml = ${Component_MAWP.buffer} mm <  tmin and tmm < 0.9 * tam = ${Component_MAWP.buffer1} mm <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result += `tam - FCAml = ${Component_MAWP.buffer} mm <  tmin = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      }
    }
    //added by shameer - end

    if (Component_MAWP.intEquip !== 6) {
      // non tank
      let aa = 0.5 * Component_MAWP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAWP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  >=  max[0.5 * tmin, t_lim] = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  <  max[0.5 * tmin, t_lim] = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAWP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  >=  max[0.5 * tmin, t_lim] = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  <  max[0.5 * tmin, t_lim] = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // tank
      let aa = 0.6 * Component_MAWP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAWP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  >=  max[0.6 * tmin, t_lim] = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  <  max[0.6 * tmin, t_lim] = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAWP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  >=  max[0.6 * tmin, t_lim] = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  <  max[0.6 * tmin, t_lim] = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    }
    if (key1 === 0 && key2 === 0) {
      if (key3 === 1) {
        Component_MAWP.strD_result = "Fail";
        result += `</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>`;
      } else {
        Component_MAWP.strD_result = "Pass";
        result +=
          '</br><font color="blue">General Metal Loss passed Level 1 assessment.</font>  </br>';
      }
    } else {
      Component_MAWP.strD_result = "Fail";
      result +=
        '</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>';
    }

    this.gmlCalcResult = result;

    return result;
  }
  private static getActiveReportComponent(): typeof Component_MAWP | typeof Component_MAEP {
  return GML_module.intLoadingType === 1 ? Component_MAEP : Component_MAWP;
}
  public static GML_report(): string {
   // let report: string = "";

    //const format = "dd/MM/yyyy";
    //const locale = "en-US";
    //const dt1 = new Date();
    //const reportDate = formatDate(dt1, format, locale);
    
   //const component = this.getActiveReportComponent();
   //console.log('Generating report for component:', component);
    //report += this.getReportHeader(reportDate,component);
    //report += this.getReportBody(reportDate,component);

    //return report;
     return GMLReportService.generate();
  }

  private static getReportHeader(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP): string {
    let header: string = "";

    header +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 4</center>";
    header += "<center>Assessment of General Metal Loss</center></br></br>";

    header += reportDate + "</br>";
    header += "Page: 1</br></br></br>";

    const sRefinery: string = "Facility: ";
    const sPlant: string = "Plant: ";
    const sEquipment: string = "Equipment: ";
    const sAnalyst: string = "Analyst: ";

    header += sRefinery + Component_MAWP.strFacility + "</br>";
    header += sPlant + Component_MAWP.strPlant + "</br>";
    header += sEquipment + Component_MAWP.strEquipment + "</br>";
    header += sAnalyst + Component_MAWP.strAnalyst + "</br></br></br>";

    header += this.getReportList();

    return header;
  }

  private static getReportList(): string {
    return `  
        <ol class="appAndLimitList">  
          <li>The original design criteria were in accordance with a recognized code or standard.</li>  
          <li>The component is not operating in the creep range. The design temperature is less than or equal to the temperature limit in Table 4.1.</li>  
          <li>The region of metal loss has relatively smooth contours without notches, i.e. negligible local stress concentrations.</li>  
          <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
          <li>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:  
            <ol type="a" class="appAndLimitList">  
              <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
              <li>Spherical pressure vessels and storage spheres</li>  
              <li>Spherical, elliptical and torispherical formed heads</li>  
              <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
              <li>Cylindrical atmospheric storage tank shell courses</li>  
            </ol>  
          </li>  
        </ol>  
        </br>`;
  }

  private static getReportBody(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP
  ): string {
    let body: string = "";

    body += this.getComponentInformation(component);

    body += '<div class="pageBreak"></div>';

    // SECOND PAGE

    body += this.getSecondPageInformation(reportDate,component);

    body += "Assessment Results :</br></br>";
    body +=
      "All the conditions in the Applicability and Limitations section are met.</br></br>";

    body += this.gmlCalcResult;

    return body;
  }

  private static getComponentInformationUs(component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
    // US Customary
    if (component.intEquip != 8)
      report += `Design pressure or vessel MAWP (psi) = ${component.sngP_d.toFixed(
        1
      )}</br>`;
    else
      report += `Design Maximum Fill Height (ft) = ${CalcTemplate.sngMFH_d.toFixed(
        2
      )}</br>`;
    if (
      !Number.isNaN(Component_MAWP.sngTemp_d) &&
      Component_MAWP.sngTemp_d != -1
    )
      report += `Design temperature (deg-F) = ${Component_MAWP.sngTemp_d.toFixed(
        2
      )}</br>`;
    else report += "Design temperature (deg-F) = N/A</br>";
    // report += `Inside diameter corrected for FCA as applicable, D (inch) = ${Component_MAWP.sngID.toFixed(
    //   3
    // )}</br>`;
    //shameer - new requirement -start
    if (component.intEquip != 8){
    report += `Nominal Thickness (inch) = ${component.sngtnom.toFixed(
      3
    )}</br>`;
  }
    //shameer - new requirement -end
    if (component.intEquip != 8) {
      // non-tanks
      report += `Current measured (uniform) thickness, trd (inch) = ${component.sngtrd.toFixed(
        3
      )}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (inch) = ${component.sngFCA.toFixed(
        3
      )}</br>`;
    } else {
      report +=
        "Current measured (uniform) thickness, trd (inch) = N/A</br>";
      report +=
        "Future corrosion allowance, FCA = FCAi + FCAe (inch) = N/A</br>";
    }
    report += `Future corroded thickness, tc (inch) = ${component.sngtc.toFixed(
      3
    )}</br>`;
    report += `Minimum required thickness, tmin (inch) = ${component.sngtmin.toFixed(
      3
    )}</br>`;
    if (component.intEquip != 8) {
      report += `MAWP of the component based on tc, MAWP (psi) = ${Component_MAWP.sngMAWP.toFixed(
        1
      )}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (ft) = ${CalcTemplate.sngMFH.toFixed(
        2
      )}</br></br>`;
    }
    return report;
  }

   
  private static getComponentInformation(component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
   
    //shameer -start
    report += "</br>Type A Component Screening Result:</br>";
      // Use the active component's unit selection for labels
  const unitIsUs = component.intUnit_select == 0;

if(parseInt(localStorage.getItem("TypeAradioselection")) == 1) // for vertical popup
  {
    // for Vertical Vessel

        const userinputs = localStorage.getItem('verticalinputs');
        const Input_data = userinputs ? JSON.parse(userinputs) : null;
        const a1 = Input_data.inputvalue1;
        const a2 = Input_data.inputvalue2;

        if(component.intUnit_select == 0) //us customary
        {
        const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
        const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
        report += lbl1+a1+"</br>"+lbl2+a2;
      
        }
        else if(component.intUnit_select == 1) //si units
        {
        const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
        const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";             
        report += lbl1+a1+"</br>"+lbl2+a2;

        }

} 
 else if (parseInt(localStorage.getItem("TypeAradioselection")) == 2) //for horizontal popup
{
          //for Horizontal Vessel

          const userinputs = localStorage.getItem('horizontalinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;

          if(component.intUnit_select == 0) //us customary
          {
          const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
          const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
          report += lbl1+a1+"</br>"+lbl2+a2;

          }
          else if(component.intUnit_select == 1) //si units
          {
          const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
          const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
          report += lbl1+a1+"</br>"+lbl2+a2;

          }

}
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 3) //for Carbon and low alloy
{
          const userinputs = localStorage.getItem('carbonsteelinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
           
          if(component.intUnit_select == 0) //us customary
             {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    report += lbl1+a1+"</br>"+lbl2+a2;

             }
         else if(component.intUnit_select == 1) //si units
             {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    report += lbl1+a1+"</br>"+lbl2+a2;
              
             }

}
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 4) //for High alloy and Nonferrous
{
                //for High Alloy and Nonferrous Steel

              const userinputs = localStorage.getItem('highalloyinputs');
              const Input_data = userinputs ? JSON.parse(userinputs) : null;
              const a1 = Input_data.inputvalue1;
              const a2 = Input_data.inputvalue2;

              if(component.intUnit_select == 0) //us customary
              {
                const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                report += lbl1+a1+"</br>"+lbl2+a2;

              }
              else if(component.intUnit_select == 1) //si units
              {
                const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                report += lbl1+a1+"</br>"+lbl2+a2;
  
              }

}

    this.inttypeA_passorfail = parseInt(localStorage.getItem("TypeAPassorFail")) || 0;
    if(this.inttypeA_passorfail == 1)
    {
      report += "</br>The component meets the Type A screening criteria.</br></br>";
    }else if(this.inttypeA_passorfail == 0)
    {
      report += "</br>The component deosn't meet the Type A screening criteria.</br></br>";
    }

    //shameer -end
    report += "Component Information :</br></br>";
    //sooraj -start
    if (component.intEquip === 0)
      report += "Component type = Cylinder</br>";
    else if (component.intEquip === 1)
      report += "Component type = Cone</br>";
    else if (component.intEquip === 2)
      report += "Component type = Sphere</br>";
    else if (component.intEquip === 3)
      report += "Component type = Elliptical Head</br>";
    else if (component.intEquip === 4)
      report += "Component type = F&D Head</br>";
    else if (component.intEquip === 5)
      report += "Component type = B31.3 Piping</br>";
    else if (component.intEquip === 6)
      report += "Component type = B31.4 Piping</br>";
    else if (component.intEquip === 7)
      report += "Component type = B31.8 Piping</br>";
    else report += "Component type = Tank</br>";
    //sooraj -end
    
    if (component.intUnit_select == 0) {
      report += this.getComponentInformationUs(component);
    } else {
      report += this.getComponentInformationSi(component);
    }
    return report;
  }

  private static getComponentInformationSi(component: typeof Component_MAWP | typeof Component_MAEP) {
    let report: string = "";
    // SI

    if (component.intEquip != 8)
      report += `Design pressure or vessel MAWP (MPa) = ${component.sngP_d.toFixed(
        2
      )}</br>`;
    else
      report += `Design Maximum Fill Height (m) = ${CalcTemplate.sngMFH_d.toFixed(
        2
      )}</br>`;
    if (
      !Number.isNaN(Component_MAWP.sngTemp_d) &&
      Component_MAWP.sngTemp_d != -1
    )
      report += `Design temperature (deg-C) = ${Component_MAWP.sngTemp_d.toFixed(
        2
      )}</br>`;
    else report += "Design temperature (deg-C) = N/A</br>";
    // report += `Inside diameter corrected for FCA as applicable, D (mm) = ${Component_MAWP.sngID.toFixed(
    //   1
    // )}</br>`;

      //shameer - new requirement -start
      if (component.intEquip != 8){
        report += `Nominal Thickness (mm) = ${component.sngtnom.toFixed(
          3
        )}</br>`;
      }
        //shameer - new requirement -end
    if (component.intEquip != 8) {
      // non-tanks
      report += `Current measured (uniform) thickness, trd (mm) = ${component.sngtrd.toFixed(
        1
      )}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (mm) = ${component.sngFCA.toFixed(
        1
      )}</br>`;
    } else {
      report +=
        "Current measured (uniform) thickness, trd (mm) = N/A</br>";
      report += "Future corrosion allowance, FCA = FCAi + FCAe (mm) = N/A</br>";
    }
    report += `Future corroded thickness, tc (mm) = ${component.sngtc.toFixed(
      1
    )}</br>`;
    report += `Minimum required thickness, tmin (mm) = ${component.sngtmin.toFixed(
      1
    )}</br>`;
    if (component.intEquip != 8) {
      report += `MAWP of the component based on tc, MAWP (MPa) = ${Component_MAWP.sngMAWP.toFixed(
        2
      )}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (m) = ${CalcTemplate.sngMFH.toFixed(
        2
      )}</br></br>`;
    }
    return report;
  }
  private static getSecondPageInformation(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 4</center>";
    report += "<center>Assessment of General Metal Loss</center></br></br>";

    report += reportDate + "</br>";
    report += "Page: 2</br></br></br>";

    report += `Longitudinal weld joint efficiency, E_L = ${Component_MAWP.sngE_L.toFixed(
      2
    )}</br>`;
    if (Component_MAWP.intEquip <= 1 || Component_MAWP.intEquip >= 5) {
      report += `Circumferential weld joint efficiency, E_C = ${Component_MAWP.sngE_c.toFixed(
        2
      )}</br>`;
    }
    report += `Allowable remaining strength factor, RSFa = ${CalcTemplate.sngRSF_a.toFixed(
      2
    )}</br></br></br>`;

    report += "Metal Loss Information :</br></br>";
    if (GML_module.intanalysis_type == 0)
      report += "Type of analysis = Average measured thickness</br>";
    else report += "Type of analysis = MAWP and MFH</br>";
    if (Component_MAWP.intUnit_select == 0) {
      // US Customary
      report += `Average measured thickness, tam (inch) = ${GML_module.sngtam.toFixed(
        3
      )}</br>`;
      report += `Minimum measured thickness, tmm (inch) = ${LTA_module.sngtmm.toFixed(
        3
      )}</br>`;
      report += `Future corrosion allowance inside the damage area, FCAml (inch) = ${CalcTemplate.sngFCAml.toFixed(
        3
      )}</br></br></br>`;
    } else {
      // SI
      report += `Average measured thickness, tam (mm) = ${GML_module.sngtam.toFixed(
        1
      )}</br>`;
      report += `Minimum measured thickness, tmm (mm) = ${LTA_module.sngtmm.toFixed(
        1
      )}</br>`;
      report += `Future corrosion allowance inside the damage area, FCAml (mm) = ${CalcTemplate.sngFCAml.toFixed(
        1
      )}</br></br></br>`;
    }
    return report;
  }
}
